@if (icon && iconConfig.placement === 'prefix') {
<fa-icon class="button-icon" [icon]="icon" [class.mr-1]="!!text"></fa-icon>
} @if (text) {
{{ text }}
} @if (icon && iconConfig.placement === 'suffix') {
<fa-icon class="button-icon" [icon]="icon" [class.ml-1]="!!text"></fa-icon>
}
<ng-content></ng-content>
